import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { AnchorItemListTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackAnchorItemListFunctionArgs {
  readonly items: {
    readonly item_id: string;
    readonly item_order: number;
  }[];
}

interface TrackAnchorItemListFunction {
  (args: TrackAnchorItemListFunctionArgs): void;
}

interface UseTrackAnchorItemListFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackAnchorItemListFunction {
  (agrs: UseTrackAnchorItemListFunctionArgs): TrackAnchorItemListFunction;
}

const useTrackAnchorItemList: UseTrackAnchorItemListFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<AnchorItemListTrackingEvent>();

  const trackAnchorItemList: TrackAnchorItemListFunction = useCallback(
    ({ items }) => {
      emitUserEvent({
        event: TrackingEventName.ANCHOR_ITEM_LIST,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        items,
        userId,
        userUuid: userId,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackAnchorItemList;
};

export { useTrackAnchorItemList };
